import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_walk_report, save_walk_report, publish_walk_report, fetch_owner_walk_report } from './api';
import type { UpsertWalkReportInput } from './types';

const report_key = (booking_id: string) => ['vendor-walk-report', booking_id] as const;
const owner_report_key = (booking_id: string) => ['owner-walk-report', booking_id] as const;

export function use_walk_report(booking_id: string, enabled = true) {
  return useQuery({
    queryKey: report_key(booking_id),
    queryFn: () => fetch_walk_report(booking_id),
    enabled: enabled && booking_id.length > 0,
  });
}

export function use_save_walk_report(booking_id: string) {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: report_key(booking_id) });
    qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
  };
  const save_m = useMutation({ mutationFn: (input: UpsertWalkReportInput) => save_walk_report(booking_id, input), onSuccess: invalidate });
  const publish_m = useMutation({ mutationFn: () => publish_walk_report(booking_id), onSuccess: invalidate });
  return { save_m, publish_m };
}

/** Owner-side: the published report for a booking (null while DRAFT/none). */
export function use_owner_walk_report(booking_id: string, enabled = true) {
  return useQuery({
    queryKey: owner_report_key(booking_id),
    queryFn: () => fetch_owner_walk_report(booking_id),
    enabled: enabled && booking_id.length > 0,
  });
}
